import Enumerable from "linq";
import {
  IEntity,
  IEntityGettable,
  IAllEntitiesGettable
} from "../domain/entity";

export class CachedRepository<TId, TEntity extends IEntity<TId>> implements IEntityGettable<TId, TEntity>, IAllEntitiesGettable<TId, TEntity> {
  constructor(private _createCache: () => Promise<TEntity[]>, private areEqual: (s: TId, d: TId) => boolean = (s, d) => s === d) {
    this.clearCache();
  }

  public clearCache() {
    this._cache = null;
  }

  private _cache: TEntity[];

  private async getCache(): Promise<TEntity[]> {
    if (this._cache === null) {
      this._cache = await this._createCache();
    }
    return this._cache;
  }

  async getEntity(id: TId): Promise<TEntity> {
    return Enumerable.from(await this.getCache())
      .first(e => this.areEqual(e.id, id));
  }

  async getAllEntities(): Promise<TEntity[]> {
    return this.getCache();
  }
}
